import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {MessagingService} from '../../../../../core/service/messaging.service';
import {AuthService} from '../../../../../core/service/auth.service';
import {VnaCampaignSelected} from '../../model/vna_campaign_selected';
import {VnaCampaignService} from '../../services/vna-campaign.service';

const SELECT_MULTIPLE_VNA_ACTION_CAMPAIGN_VALUE_ACCESSOR: any = {
    multi: true,
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => SelectVnaCampaignActionMultipleComponent)
};

@Component({
    selector: 'app-select-vna-campaign-action-multiple',
    template: `
      <ng-multiselect-dropdown [data]="actions" [(ngModel)]="acts" (onSelect)="selected($event)" (onSelectAll)="selected($event)" [placeholder]="textDefault" [settings]="settings" >
      </ng-multiselect-dropdown>
      `,
    styleUrls: ['./select-vna-campaign-action-multiple.component.scss'],
    providers: [SELECT_MULTIPLE_VNA_ACTION_CAMPAIGN_VALUE_ACCESSOR]
})
export class SelectVnaCampaignActionMultipleComponent implements OnInit, ControlValueAccessor {

    @Input() valueField: string = 'pk';
    @Input() textField: string = 'name';
    @Input() textDefault: string = 'Select campaign actions';

    @Input() pkCamp: number;

    actions: Array<Object> = [];
    _acts: number;

    settings: Object;

    constructor(private campHandler: VnaCampaignService, private messaging: MessagingService, private auth: AuthService) {

        this.settings = {
            singleSelection: false,
            idField: this.valueField,
            textField: this.textField,
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 10,
            allowSearchFilter: true
        }
    }

    ngOnInit() {

        this.settings['textField'] = this.textField;

        if(this.pkCamp){
            this.campHandler.findCampaignActions(this.pkCamp).subscribe(
                (result) => {
                    this.actions = result;
                }
            )
        }

        this.messaging.message.subscribe(
            (value) => {
                if(value instanceof VnaCampaignSelected){
                    this.campHandler.findCampaignActions(value.getPkCampaign()).subscribe(
                        (result) => {
                            this.actions = result;
                        }
                    )
                }
            }
        )

    }


    selected(value: any) {
        this.propagateChange(this._acts);
    }


    get acts(): any { return this._acts; };

    set acts(v: any) {
        this._acts = v;
        this.propagateChange(this._acts);
    }

    propagateChange = (_: any) => {};

    registerOnChange(fn: any): void {
        this.propagateChange = fn;
    }

    registerOnTouched(fn: any): void {
    }

    writeValue(value: any): void {
        this._acts = value;
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/vna-campaign/components/select-vna-campaign-action-multiple/select-vna-campaign-action-multiple.component.ts